// frontend/src/types/billing.types.ts

export type PlanTier = 'free' | 'premium' | 'parent_standard' | 'parent_plus';

export interface Plan {
  id: string;
  tier: string;
  name: string;
  price_try: number;
  type?: string;
  billing_period?: string;
  features: string[];
  description?: string;
  max_courses?: number | null;
  max_lessons_per_day?: number | null;
  max_ai_messages_per_day?: number | null;
  max_code_evaluations_per_day?: number | null;
  max_games_per_day?: number | null;
  max_projects?: number | null;
  max_quizzes_generated_per_day?: number | null;
  max_quizzes_solved_per_day?: number | null;
  is_active?: boolean;
  show_on_landing?: boolean;
  badge_label?: string;
  display_order?: number;
  daily_ai_message_limit?: number | null; // null = sınırsız (geriye dönük uyumluluk)
}

/**
 * PostgreSQL `subscription_status` enum tipine tam uyumlu merkezi durum sabitleri.
 * Kod genelinde büyük harfli ("ACTIVE", "CANCELED") stringler yerine bu sabit kullanılmalıdır.
 */
export const SubscriptionStatus = {
  ACTIVE: 'active',
  CANCELLED: 'cancelled',
  CANCELED: 'cancelled', // Tek 'l' ile yazım için alias
  EXPIRED: 'expired',
  PENDING: 'pending',
  PAST_DUE: 'past_due',
  TRIALING: 'trialing',
} as const;

export type SubscriptionStatusType = (typeof SubscriptionStatus)[keyof typeof SubscriptionStatus];

export interface Subscription {
  id: string;
  user_id: string;
  plan_id: string;
  status: SubscriptionStatusType;
  started_at: string;
  current_period_end: string;
  simulated?: boolean;
  plans: Plan;
}

export interface AiUsageToday {
  used: number;
  limit: number | null;
  extraPackMessages: number;
  remaining: number | null;
}

export interface Bootcamp {
  id: string;
  title: string;
  description: string | null;
  duration_weeks: number;
  price_try: number;
  start_date: string | null;
  max_seats: number | null;
}

// Planların renklerini/ikonlarını UI'da tutmak için sabit harita
export const PLAN_META: Record<PlanTier, { icon: string; color: string; badge?: string }> = {
  free: { icon: '🌱', color: 'var(--gray)' },
  premium: { icon: '🚀', color: 'var(--primary-light)', badge: 'Popüler' },
  parent_standard: { icon: '👨‍👩‍👧', color: 'var(--secondary)' },
  parent_plus: { icon: '⭐', color: 'var(--accent)', badge: 'En İyi' },
};
